import type { StoreResponse } from 'api/Stores/types'
import { userPrivileges } from 'api/User/selectors'
import { connect } from 'react-redux'
import type { State } from 'store/types'

import StoreDetailsInfo from './StoreDetailsInfo'

interface OwnProps {
  countryId: string
  details: Partial<StoreResponse>
  exposTimestamp?: string
  resaTimestamp?: string
  trafficTimestamp?: string
}

const mapStateToProps = (state: State, { exposTimestamp, resaTimestamp, trafficTimestamp }: OwnProps) => ({
  exposTimestamp,
  resaTimestamp,
  trafficTimestamp,
  userPrivileges: userPrivileges(state),
})

export default connect(mapStateToProps)(StoreDetailsInfo as any)
